import styled, { createGlobalStyle } from 'styled-components';
import { Color, Grid, Shadow } from '../../../app/StyleGuide';
import { PrimaryButton } from '../../../components/Buttons';
import { PageTitle, RaisedContainer } from '../../../components/Layout';

export const ContentContainer = styled(RaisedContainer)`
  display: flex;
  flex-direction: column;
  align-items: center;
  grid-gap: ${Grid._8};
  max-width: 820px;
  padding: ${Grid._6};
`;

export const ContentTitle = styled(PageTitle)`
  text-align: center;

  p {
    margin: 0;
  }
`;

export const ContinueButton = styled(PrimaryButton)`
  min-width: 220px;
`;

export const ListItem = styled.button`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${Grid._3} ${Grid._6};
  background: ${Color.Gray._05};
  border: none;
  width: 100%;
  box-shadow: ${Shadow.light};
`;

export const ViewContainer = styled.div`
  width: 100%;
  max-width: 550px;
`;

export const LicenseAlreadyGrantedContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${Grid._3};

  > button {
    width: 100%;
    max-width: 280px;

    &:first-of-type {
      margin: ${Grid._7} 0 ${Grid._3} 0;
    }
  }
`;

export const BodyStyle = createGlobalStyle<{ background: string }>`
  body {
    background: ${props => props.background} !important;
    height: 100vh;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: center;
  margin: ${Grid._4} 0;

  img {
    height: 140px;
  }

  svg {
    height: 140px;
    max-width: 200px;
  }
`;
